module.exports = "<h2 id=\"opening-hours\">OPENING HOURS</h2>\n<p>WEDNESDAY — SATURDAY<br>7 PM — 11.30 PM</p>\n";


//////////////////
// WEBPACK FOOTER
// ./src/assets/copy/opening_en.md
// module id = XkuR
// module chunks = 0